// mutations
export var MUTATE_DETAIL = 'MUTATE_DETAIL';
export var MUTATE_MODAL_STATUS = 'MUTATE_MODAL_STATUS';
export var MUTATE_PROMPT_STATUS = 'MUTATE_PROMPT_STATUS';
export var MUTATE_PERFORMANCEID = 'MUTATE_PERFORMANCEID';
export var MUTATE_REGISTER = 'MUTATE_REGISTER';
export var MUTATE_SHOWS = 'MUTATE_SHOWS';
export var MUTATE_SHOW = 'MUTATE_SHOW';
export var MUTATE_TICKETS = 'MUTATE_TICKETS';
export var MUTATE_TICKET = 'MUTATE_TICKET';
export var MUTATE_SALE_REMIND_REGISTER = 'MUTATE_SALE_REMIND_REGISTER';
export var MUTATE_SALE_REMIND = 'MUTATE_SALE_REMIND';
export var MUTATE_ANSWER = 'MUTATE_ANSWER';
export var MUTATE_PREVIEW_STATUS = 'MUTATE_PREVIEW_STATUS';
export var MUTATE_SESSIONS = 'MUTATE_SESSIONS';
export var MUTATE_AREAS = 'MUTATE_AREAS';
export var MUTATE_SESSION_LIST = 'MUTATE_SESSION_LIST';
// 展示优惠折扣
export var MUTATE_PROMOTION_LIST = 'MUTATE_PROMOTION_LIST';
export var MUTATE_NEW_MODAL_STATUS = 'MUTATE_NEW_MODAL_STATUS';
// 选择需要开售提醒的票档
export var MUTATE_SELECTEDREMINDTICKET = 'MUTATE_SELECTEDREMINDTICKET';
// 设置是否需要限流
export var MUTATE_IS_LIMITING_STATUS = 'MUTATE_IS_LIMITING_STATUS';
// 限流情况下设置是否需要跳转到首页
export var MUTATE_LIMITING_NEED_REDIRECT = 'MUTATE_LIMITING_NEED_REDIRECT';
// 设置是否显示是视频介绍
export var MUTATE_IS_SHOW_VIDEO = 'MUTATE_IS_SHOW_VIDEO';
// 设置m站预览引导是否展示
export var MUTATE_SHOWMPREVIEW = 'MUTATE_SHOWMPREVIEW';
// 设置m站打开app的引导
export var MUTATE_MJUMPMODAL = 'MUTATE_MJUMPMODAL';
export var MUTATE_MCODE = 'MUTATE_MCODE';
export var MUTATE_MPLATFORMS = 'MUTATE_MPLATFORMS';
export var MUTATE_MQRCODE = 'MUTATE_MQRCODE';
// actions
export var RESET_DETAIL = 'RESET_DETAIL';
export var GET_SESSIONS = 'GET_SESSIONS';
export var GET_AREAS = 'GET_AREAS';
export var GET_DETAIL = 'GET_DETAIL';
export var GET_NEED_ANSWER = 'GET_NEED_ANSWER';
export var TOGGLE_MODAL = 'TOGGLE_MODAL';
export var TOGGLE_PROMPT = 'TOGGLE_PROMPT';
export var TOGGLE_PREVIEW = 'TOGGLE_PREVIEW';
export var SET_DETAIL_PERFORMANCEID = 'SET_DETAIL_PERFORMANCEID';
export var CHANGE_REGISTER = 'CHANGE_REGISTER';
export var GET_TICKETS = 'GET_TICKETS';
export var GET_SHOWS = 'GET_SHOWS';
export var CHANGE_SHOW = 'CHANGE_SHOW';
export var CHANGE_TICKET = 'CHANGE_TICKET';
export var SEND_REGISTER_REQ = 'SEND_REGISTER_REQ';
export var SET_SALE_REMIND = 'SET_SALE_REMIND';
export var SAVE_SALE_REMIND_INFO = 'SAVE_SALE_REMIND_INFO';
export var HANDLE_SHOW = 'HANDLE_SHOW';
export var CHECK_AB_VERSION = 'CHECK_AB_VERSION';
export var UPDATE_SALE_LABELS = 'UPDATE_SALE_LABELS';
export var MUTATE_SALE_LABELS = 'MUTATE_SALE_LABELS';
export var TOGGLE_NEW_MODAL = 'TOGGLE_NEW_MODAL';
export var TOGGLE_MPREVIEW = 'SHOW_MPREVIEW';
export var TOGGLE_MJUMPMODAL = 'TOGGLE_MJUMPMODAL';
export var TOGGLE_MCODE = 'TOGGLE_MCODE';
// 选择需要开售提醒的票档
export var SELECTED_REMIND_TICKETFILE = 'SELECTED_REMIND_TICKETFILE';

// getters
export var GETTER_SHARE_OPTIONS = 'GETTER_SHARE_OPTIONS';
export var GETTER_DETAIL = 'GETTER_DETAIL';
export var GETTER_MSITEPLATEFORMS = 'GETTER_MSITEPLATEFORMS';
export var GETTER_MQRCODE = 'GETTER_MQRCODE';
export var GETTER_BUTTON_TYPES = {
  'XZGP': 1,
  // 选座购票
  'LJYD': 2,
  // 立即预订
  'LJGP': 3,
  // 立即购票
  'YSQ': 4,
  // 已售罄
  'QHDJ': 5,
  // 缺货登记
  'YJS': 6,
  // 已结束
  'KQTX': 7,
  // 预约抢购
  'DJS': 8,
  // 倒计时
  'JJKS': 9,
  // 即将开售
  'JJYS': 10,
  // 即将开抢
  'YQQK': 12 // 一起去看
};

export var SHOW_MODAL_TYPE = {
  CONFIGE_MODAL: 1,
  // 配置弹窗
  REALNAME_MODAL: 2,
  // 实名制弹窗
  POLICE_MODAL: 3 // 警方防骗提示弹窗
};

export default {
  MUTATE_DETAIL: MUTATE_DETAIL,
  MUTATE_MODAL_STATUS: MUTATE_MODAL_STATUS,
  MUTATE_PROMPT_STATUS: MUTATE_PROMPT_STATUS,
  MUTATE_PERFORMANCEID: MUTATE_PERFORMANCEID,
  MUTATE_REGISTER: MUTATE_REGISTER,
  MUTATE_SHOWS: MUTATE_SHOWS,
  MUTATE_SHOW: MUTATE_SHOW,
  MUTATE_TICKETS: MUTATE_TICKETS,
  MUTATE_TICKET: MUTATE_TICKET,
  MUTATE_SALE_REMIND_REGISTER: MUTATE_SALE_REMIND_REGISTER,
  MUTATE_SALE_REMIND: MUTATE_SALE_REMIND,
  MUTATE_ANSWER: MUTATE_ANSWER,
  MUTATE_PREVIEW_STATUS: MUTATE_PREVIEW_STATUS,
  MUTATE_SESSIONS: MUTATE_SESSIONS,
  MUTATE_AREAS: MUTATE_AREAS,
  MUTATE_SESSION_LIST: MUTATE_SESSION_LIST,
  // 展示优惠折扣
  MUTATE_PROMOTION_LIST: MUTATE_PROMOTION_LIST,
  MUTATE_NEW_MODAL_STATUS: MUTATE_NEW_MODAL_STATUS,
  // 选择需要开售提醒的票档
  MUTATE_SELECTEDREMINDTICKET: MUTATE_SELECTEDREMINDTICKET,
  // 设置是否需要限流
  MUTATE_IS_LIMITING_STATUS: MUTATE_IS_LIMITING_STATUS,
  // 限流情况下设置是否需要跳转到首页
  MUTATE_LIMITING_NEED_REDIRECT: MUTATE_LIMITING_NEED_REDIRECT,
  // 设置是否显示是视频介绍
  MUTATE_IS_SHOW_VIDEO: MUTATE_IS_SHOW_VIDEO,
  // 设置m站预览引导是否展示
  MUTATE_SHOWMPREVIEW: MUTATE_SHOWMPREVIEW,
  // 设置m站打开app的引导
  MUTATE_MJUMPMODAL: MUTATE_MJUMPMODAL,
  MUTATE_MCODE: MUTATE_MCODE,
  MUTATE_MPLATFORMS: MUTATE_MPLATFORMS,
  MUTATE_MQRCODE: MUTATE_MQRCODE,
  // actions
  RESET_DETAIL: RESET_DETAIL,
  GET_SESSIONS: GET_SESSIONS,
  GET_AREAS: GET_AREAS,
  GET_DETAIL: GET_DETAIL,
  GET_NEED_ANSWER: GET_NEED_ANSWER,
  TOGGLE_MODAL: TOGGLE_MODAL,
  TOGGLE_PROMPT: TOGGLE_PROMPT,
  TOGGLE_PREVIEW: TOGGLE_PREVIEW,
  SET_DETAIL_PERFORMANCEID: SET_DETAIL_PERFORMANCEID,
  CHANGE_REGISTER: CHANGE_REGISTER,
  GET_TICKETS: GET_TICKETS,
  GET_SHOWS: GET_SHOWS,
  CHANGE_SHOW: CHANGE_SHOW,
  CHANGE_TICKET: CHANGE_TICKET,
  SEND_REGISTER_REQ: SEND_REGISTER_REQ,
  SET_SALE_REMIND: SET_SALE_REMIND,
  SAVE_SALE_REMIND_INFO: SAVE_SALE_REMIND_INFO,
  HANDLE_SHOW: HANDLE_SHOW,
  CHECK_AB_VERSION: CHECK_AB_VERSION,
  UPDATE_SALE_LABELS: UPDATE_SALE_LABELS,
  MUTATE_SALE_LABELS: MUTATE_SALE_LABELS,
  TOGGLE_NEW_MODAL: TOGGLE_NEW_MODAL,
  TOGGLE_MPREVIEW: TOGGLE_MPREVIEW,
  TOGGLE_MJUMPMODAL: TOGGLE_MJUMPMODAL,
  TOGGLE_MCODE: TOGGLE_MCODE,
  // 选择需要开售提醒的票档
  SELECTED_REMIND_TICKETFILE: SELECTED_REMIND_TICKETFILE,
  // getters
  GETTER_SHARE_OPTIONS: GETTER_SHARE_OPTIONS,
  GETTER_DETAIL: GETTER_DETAIL,
  GETTER_MSITEPLATEFORMS: GETTER_MSITEPLATEFORMS,
  GETTER_MQRCODE: GETTER_MQRCODE,
  GETTER_BUTTON_TYPES: GETTER_BUTTON_TYPES,
  SHOW_MODAL_TYPE: SHOW_MODAL_TYPE
};